// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__usWbE","spinner":"Spinner_spinner__ftcyF","spin":"Spinner_spin__i+TEO","text":"Spinner_text__eLIdV"};